<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <b-form>
            <b-form-group
              label="Cuenta"
              label-for="bancoCuentaNombre"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="bancoCuentaNombre" 
                v-model= "bancoCuentaNombre" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <app-banco-cuenta-destino
              label="Destino"
              :nombre="bancoCuentaDestinoNombre"
              :lista="bancosCuentasList"
              :labelCols="labelCols"
              :valido="bancoCuentaDestinoValida"
              :msjInvalido="bancoCuentaDestinoInvalidaMsj"
              @updated="bancoCuentaDestinoActualizada">
            </app-banco-cuenta-destino>

            <b-form-group
              label="Fecha Cred/Deb"
              label-for="fechaCreditoDebito"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCreditoDebito" 
                v-model="fechaCreditoDebito" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Importe"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Referencia"
              label-for="observaciones"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="observaciones"
                v-model.trim="$v.observaciones.$model" 
                :state="observacionesValidas"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import BancoCuentaDestino from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { required, decimal, minValue, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancomovimiento/getField',
  mutationType: 'bancomovimiento/updateField',
});

export default {
  name: 'TransferenciaCuentas',
  components: {
    appBancoCuentaDestino: BancoCuentaDestino,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  props: {
    cuenta: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      noValidar: true,
      bancoCuentaDestinoValida: null,
      bancoCuentaDestinoInvalidaMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      bancosCuentas: [],
      bancosCuentasList: [],

      labelCols: 3,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',
    }
  },
  computed: {
    ...mapFields([
      'id',
      'bancoCuentaNombre',
      'bancoCuentaDestino',
      'bancoCuentaDestinoNombre',
      'fechaCreditoDebito',
      'importe',
      // 'conciliado',
      'observaciones',
    ])
  },  
  created() {
    this.showSpinner();

    this.$store.dispatch('bancomovimiento/inicializarTransferencia')
      .then(() => {
        this.getDatosAdicionales();
        return;
      })
      .then(() => {
          if (this.cuenta != null) {
          this.$store.dispatch('bancomovimiento/setBancoCuenta', this.cuenta);    
        }   
      })
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      /* Solo se permiten transferencias entre cuentas de la misma moneda */
      let params = {
        monedaId: this.cuenta ? this.cuenta.monedaId : 0,
      }
      this.$store.dispatch('bancoscuentas/getList', params)
        .then(() => {
            this.bancosCuentas = this.$store.getters['bancoscuentas/list']
            this.bancosCuentasList = this.$store.getters['bancoscuentas/selectList']
          })
          .catch(() => this.showAlert('Se produjo un error al recuperar la información de cuentas bancarias.', 'danger'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal || !this.$v.importe.minValue) {
            this.importeInvalidoMsj = 'El importe del movimiento debe ser un valor numérico positivo';
          }
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las referencias del movimiento sólo puede contener hasta 250 caracteres.';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let bancoCuentaOrigenId = 0;
      if (this.cuenta) {
        if (this.cuenta.id) {
          bancoCuentaOrigenId = this.cuenta.id;
        }
      }      

      let bancoCuentaDestinoError = true;
      if (this.bancoCuentaDestino) {
        if (this.bancoCuentaDestino.id) {
          if (this.bancoCuentaDestino.id != 0) {
            bancoCuentaDestinoError = Boolean(false);
          }
        }
      }
      if (bancoCuentaDestinoError) {
        save = false;
        this.bancoCuentaDestinoValida = false;
        this.bancoCuentaDestinoInvalidaMsj = 'Debe seleccionar la cuenta de destino correspondiente.';
      } else {
        if (this.bancoCuentaDestino.id == bancoCuentaOrigenId) {
          save = false;
          this.bancoCuentaDestinoValida = false;
          this.bancoCuentaDestinoInvalidaMsj = 'La cuenta de destino no puede ser la misma que la de origen.';
        }
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('bancomovimiento/save')
            .then(() => this.$emit('close', true))
            .catch( error => this.showAlert(error, 'danger'))
            .finally(() => this.hideSpinner())
        }
      } 
    },
    close() {
      this.$emit('close', false);
    },
    bancoCuentaDestinoActualizada(bancoCuentaNombre) {
      this.bancoCuentaDestinoNombre = bancoCuentaNombre;

      let bancoCuentaDestino = null;
      if (this.bancoCuentaDestinoNombre) {
        bancoCuentaDestino = this.getSelected(this.bancosCuentas, this.bancoCuentaDestinoNombre);
      }
      this.$store.dispatch('bancomovimiento/setBancoCuentaDestino', bancoCuentaDestino);
      this.bancoCuentaDestinoValida = null;
      this.bancoCuentaDestinoInvalidaMsj = '';
    },
  },
  watch: {
  },
  validations: {
    importe: {
      decimal,
      minValue: minValue(0.01),      
    },
    observaciones: {
      maxLength: maxLength(250)
    }
  },  
}
</script>

<style>
</style>
